export default __webpack_public_path__ + "static/media/drzewo_2.09e548e0.svg";